import "./index.css";
import Button from "@mui/material/Button";
import AlertDialogForm from "../SwitchOnApprovalList/SwitchOnApprovalDialog";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import axios from "axios";
import ReassignAlertDialogForm from "./reassign_alertdialog";
import ReassignIcon from "@mui/icons-material/Autorenew";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import loadergif from "../../../assets/images/BG-switch loader_2.gif";
import * as XLSX from "xlsx";
import {
  VAVE,
  GETIL1PDDATABYEMPID,
  GETIL1SOURCINGDATABYEMPID,
GETIL1,
  DOWNLOADUPLOADEDUSERFILE,
} from "../../AppConstant";

import { Pagination, Stack } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import { sourcingEmpIds, iL1ReassignEmpIds } from "../switch_on_userlist";

function SwitchOnUserShowingList({ role, setIsLoading }) {
  const [refreshApi, setRefreshApi] = useState(false);
  const [allIdeas, setAllIdeas] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");
  const [ideaListByEmpId, setIdeaListByEmpId] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [viewMoreOpenDialog, setViewMoreOpenDialog] = useState(false);
  const [reAssignOpenDialog, setreAssignOpenDialog] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const totalPages = Math.ceil(ideaListByEmpId.length / itemsPerPage);
  const [selectedIdea, setSelectedIdea] = useState(null);
  const [createuri, setCreateuri] = useState("");
  const [isloading, setIsloading] = useState(false);
  const [allIdeasForDownload, setAllIdeasForDownload] = useState([]);
  const navigate = useNavigate();
  const currentEmpId = localStorage.getItem("empid");
  const handleView = (req) => {
    navigate("/IV2", { state: { request: req } });
  };

  const [filteredCommomIdeas, setFilteredIdeas] = useState([]);
  const normalize = (s) => (s || "").toString().trim().toLowerCase();
  const downloadUploadedUserDocApi = (request) => {
    setIsloading(true);
    axios({
      method: "post",
      url: VAVE + DOWNLOADUPLOADEDUSERFILE,
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: { idea_id: request.id_x },
      responseType: "blob",
    })
      .then((response) => {
        if (response.data.size === 14) {
          alert("No Data Available");
          setIsloading(false);
          return;
        }

        const contentType =
          response.headers["content-type"] || "application/pdf";
        const disposition = response.headers["content-disposition"];
        let filename = `Idea_${request.idea_unique_id}_User_Document.pdf`;

        const blob = new Blob([response.data], { type: contentType });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Clean up
        URL.revokeObjectURL(url);
        setIsloading(false);
      })
      .catch((error) => {
        window.open(selectedIdea.filepath, "_blank");
        setIsloading(false);
      });
  };
  // const handleButtonClick = (filter) => {
  //   setSelectedFilter(filter);
  //   if (filter === "All") {
  //     fetchAllData();
  //   } else {
  //     handleFilter(filter);
  //   }
  //   setCurrentPage(1);
  // };

  const handleButtonClick = (filter) => {
    setSelectedFilter(filter);
    setCurrentPage(1);
    handleFilter(filter);
  };
  const handleViewMore = (idea) => {
    setSelectedIdea(idea);
    setViewMoreOpenDialog(true);
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRequest(null);
  };

  // const handleFilter = async (status) => {
  //   const formData = new FormData();

  //   formData.append("empids", localStorage.getItem("empid") || "");
  //   formData.append("status", status);

  //   try {
  //     const url = sourcingEmpIds.includes(currentEmpId)
  //       ? GETIL1SOURCINGFILTERDATA
  //       : GETIL1PDFILTERDATA;

  //     await axios
  //       .post(VAVE + url, formData, {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       })
  //       .then((res) => {
  //         console.log("API response:", res.data);
  //         setIdeaListByEmpId(res.data.data || []);
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching ideas:", error);
  //       });
  //   } catch (error) {
  //     console.error("Upload failed:", error);
  //   } finally {
  //   }
  // };

  const handleViewMoreCloseDialog = () => {
    setViewMoreOpenDialog(false);
    setSelectedIdea(null);
  };

  const handleReassignCloseDialog = () => {
    setreAssignOpenDialog(false);
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "accepted":
        return "green";
      case "rejected":
        return "red";
      case "inprogress":
        return "orange";
      default:
        return "gray";
    }
  };

  useEffect(() => {
    fetchIdeas();
    fetchIdeasForDownload();
  }, []);



  const fetchIdeasForDownload = async () => {
    try {
      const response = await axios.get(VAVE + GETIL1, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });
      const allIdeasForDownload = response.data.data || [];
      setAllIdeasForDownload(allIdeasForDownload);
    } catch (error) {
      console.error("Error fetching ideas:", error);
    }
  };


  useEffect(() => {
    if (!refreshApi) return;
    fetchIdeas();
    handleFilter("inprogress");
    handleFilter("parked");
    setOpenDialog(false);
    setreAssignOpenDialog(false);
    setRefreshApi(false);
  }, [refreshApi]);
  // useEffect(() => {
  //   handleFilter("All");
  // }, []);
  const fetchIdeas = async () => {
    const currentEmpId = localStorage.getItem("empid") || "";
    const url = sourcingEmpIds.includes(currentEmpId)
      ? GETIL1SOURCINGDATABYEMPID
      : GETIL1PDDATABYEMPID;

    try {
      const response = await axios.get(VAVE + url + currentEmpId, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });

      const ideas = response.data.data || [];
      setAllIdeas(ideas);
      if (!refreshApi) {
        handleFilter("All", ideas); // Initial filter
      } else {
        handleFilter("inprogress", ideas);
      }
      // handleFilter("All", ideas); // Initial filter
    } catch (error) {
      console.error("Error fetching ideas:", error);
    }
  };

  const handleFilter = (filter, data = allIdeas) => {
    const currentEmpId = localStorage.getItem("empid") || "";

    const filtered =
      filter === "All"
        ? data
        : sourcingEmpIds.includes(currentEmpId)
        ? data.filter(
            (idea) =>
              idea.il1_sourcing_status?.toLowerCase() === filter.toLowerCase()
          )
        : data.filter(
            (idea) => idea.il1_pd_status?.toLowerCase() === filter.toLowerCase()
          );

    setIdeaListByEmpId(filtered);
  };

  //   const handleFilter = async (filter = "All") => {
  //     const formData = new FormData();
  //     const currentEmpId = localStorage.getItem("empid") || "";

  //     formData.append("empids", currentEmpId);

  //     try {
  //       const url = sourcingEmpIds.includes(currentEmpId)
  //         ? GETIL1SOURCINGDATABYEMPID
  //         : GETIL1PDDATABYEMPID;

  //      axios({
  //       method: "get",
  //       url: VAVE + url + currentEmpId,
  //       withCredentials: false,
  //       headers: {
  //         "Content-Type": "application/x-www-form-urlencoded",
  //       },
  //     })
  //       .then((response) => {
  // const allIdeas = response.data.data || [];

  //       const filtered =
  //         filter === "All"
  //           ? allIdeas
  //           : sourcingEmpIds.includes(currentEmpId)
  //           ? allIdeas.filter(
  //               (idea) =>
  //                 idea.il1_sourcing_status?.toLowerCase() === filter.toLowerCase()
  //             )
  //           : allIdeas.filter(
  //               (idea) =>
  //                 idea.il1_pd_status?.toLowerCase() === filter.toLowerCase()
  //             );

  //       setIdeaListByEmpId(filtered);
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching ideas:", error);
  //       });

  //     } catch (error) {
  //       console.error("Error fetching ideas:", error);
  //     }
  //   };
  const fetchAllData = () => {
    const url = sourcingEmpIds.includes(currentEmpId)
      ? GETIL1SOURCINGDATABYEMPID
      : GETIL1PDDATABYEMPID;
    axios({
      method: "get",
      url: VAVE + url + currentEmpId,
      withCredentials: false,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
      .then((res) => {
        console.log("API response:", res.data);
        setIdeaListByEmpId(res.data.data || []);
      })
      .catch((error) => {
        console.error("Error fetching ideas:", error);
      });
  };

  const downloadfiles = (ee) => {
    const hrefee = createuri;
    const link = document.createElement("a");
    link.href = hrefee;
    link.setAttribute("download", +createuri + "_.pdf");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // const filteredIdeas = ideaListByEmpId.filter((item) => {
  //   const query = searchQuery.toLowerCase();
  //   const matchesSearch = Object.values(item).some((value) =>
  //     String(value).toLowerCase().includes(query)
  //   );

  //   return matchesSearch;
  // });

  const filteredIdeas = Array.isArray(ideaListByEmpId)
    ? ideaListByEmpId.filter((item) => {
        const query = searchQuery.toLowerCase();
        return Object.values(item).some((value) =>
          String(value).toLowerCase().includes(query)
        );
      })
    : [];


    
  const paginatedIdeas = filteredIdeas.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );


  const ideaExcelDownloadSubmit = async () => {
    try {
 
      const dataToExport = allIdeasForDownload;

      const pdApproved = dataToExport.filter(
        (i) => normalize(i.il1_pd_status) === "accepted"
      ).length;
      const pdPending = dataToExport.filter(
        (i) => normalize(i.il1_pd_status) === "inprogress"
      ).length;

        const pdRejected = dataToExport.filter(
      (i) => normalize(i.il1_pd_status) === "rejected"
    ).length;

        const pdParked = dataToExport.filter(
      (i) => normalize(i.il1_pd_status) === "parked"
    ).length;
      const sourcingApproved = dataToExport.filter(
        (i) => normalize(i.il1_sourcing_status) === "accepted"
      ).length;
      const sourcingPending = dataToExport.filter(
        (i) => normalize(i.il1_sourcing_status) === "inprogress"
      ).length;

       const sourcingRejected = dataToExport.filter(
      (i) => normalize(i.il1_sourcing_status) === "rejected"
    ).length;

      const sourcingParked = dataToExport.filter(
      (i) => normalize(i.il1_sourcing_status) === "parked"
    ).length;

      const summaryAOA = [
        ["Status Summary"],
        ["", "PD", "Sourcing"],
        ["Approved", pdApproved, sourcingApproved],
        ["Rejected", pdRejected, sourcingRejected],
        ["Parked", pdParked, sourcingParked],
        ["Pending", pdPending, sourcingPending],
      ];

      const filteredData = dataToExport.map((item) => ({
        id: `SWON-${item.id_x}`,
        idea_category: item.idea_category,
        partno: item.partno,
        part_description: item.part_description,
        benefit:item.benefit,
        idea_effective:item.idea_effective,
        model:item.model,
        varient:item.varient,
        subvarient:item.subvarient,
        il1_pd_name:item.il1_pd_assigned,
        il1_pd_status: item.il1_pd_status,
        il1_sourcing_name:item.il1_sourcing_assigned,
        il1_sourcing_status: item.il1_sourcing_status,
        il1_pd_comment: item.il1_pd_comment,
        il1_sourcing_comment: item.il1_sourcing_comment,
      }));

      const workbook = XLSX.utils.book_new();

      // Summary sheet
      const summarySheet = XLSX.utils.aoa_to_sheet(summaryAOA);
      XLSX.utils.book_append_sheet(workbook, summarySheet, "Summary");

      // Ideas sheet
      const ideasSheet = XLSX.utils.json_to_sheet(filteredData);
      XLSX.utils.book_append_sheet(workbook, ideasSheet, "Ideas");

      XLSX.writeFile(workbook, "ideas_filtered.xlsx");
    } catch (error) {
      console.error("Error generating Excel:", error);
    }
  };



  return (
    <div className="container mt-2">
      {isloading ? (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div className="loadergif">
            <img src={loadergif} alt="Loading..." />
          </div>
        </div>
      ) : (
        ""
      )}
      <div className="d-flex flex-row align-items-center gap-3 flex-wrap pb-3 pt-4">
        <div className="d-flex align-items-center">
          <label className="me-2">Search</label>
          <input
            type="text"
            className="form-control"
            placeholder="Search..."
            value={searchQuery}
            onChange={(e) => {
              setSearchQuery(e.target.value);
              setCurrentPage(1);
            }}
            style={{ width: "200px" }}
          />
          
        </div>
        <div className="d-flex gap-2">
           <button
              type="button"
              className="btn btn-primary"
              onClick={ideaExcelDownloadSubmit}
            >
              Download (Total Ideas: {allIdeasForDownload.length})
            </button>
          <Button
            variant="contained"
            color={selectedFilter === "All" ? "success" : "primary"}
            onClick={() => handleButtonClick("All")}
          >
            All
          </Button>
          <Button
            variant="contained"
            color={selectedFilter === "inprogress" ? "success" : "primary"}
            onClick={() => handleButtonClick("inprogress")}
          >
            Pending
          </Button>

          <Button
            variant="contained"
            color={selectedFilter === "accepted" ? "success" : "primary"}
            onClick={() => handleButtonClick("accepted")}
          >
            Accepted
          </Button>
          <Button
            variant="contained"
            color={selectedFilter === "rejected" ? "success" : "primary"}
            onClick={() => handleButtonClick("rejected")}
          >
            Rejected
          </Button>

          <Button
            variant="contained"
            color={selectedFilter === "parked" ? "success" : "primary"}
            onClick={() => handleButtonClick("parked")}
          >
            Parked
          </Button>
        </div>
      </div>

      <div className="table-responsive">
        <table className="table table-bordered table-striped custom-table">
          <thead className="thead-dark">
            <tr>
              <th>SW Id</th>
              {selectedFilter === "All" && <th>Status</th>}
              {(selectedFilter === "inprogress" || selectedFilter === "parked") && 
                !iL1ReassignEmpIds.includes(currentEmpId) && <th>Reassign</th>}
              <th>Proposed Idea</th>
              <th>Part No</th>
              <th>Savings</th>
              <th>Aggregate</th>
              <th>Variant</th>
              <th>View More</th>
            </tr>
          </thead>
          <tbody>
            {paginatedIdeas.length === 0 ? (
              <tr>
                <td colSpan="8" className="text-center py-4">
                  No ideas found
                </td>
              </tr>
            ) : (
              paginatedIdeas.map((req, index) => (
                <tr key={req.id}>
                  <td>{req.idea_unique_id}</td>
                  {selectedFilter === "All" && (
                    <td style={{ cursor: "pointer" }}>
                      <span
                        title={
                          sourcingEmpIds.includes(currentEmpId)
                            ? req.il1_sourcing_status
                            : req.il1_pd_status
                        }
                        style={{
                          display: "inline-block",
                          width: "18px",
                          height: "18px",
                          borderRadius: "50%",
                          backgroundColor: getStatusColor(
                            sourcingEmpIds.includes(currentEmpId)
                              ? req.il1_sourcing_status
                              : req.il1_pd_status
                          ),
                          marginRight: "8px",
                        }}
                      ></span>
                    </td>
                  )}
                  {(selectedFilter === "inprogress" || selectedFilter === "parked") &&  
                    !iL1ReassignEmpIds.includes(currentEmpId) && (
                      <td
                        style={{
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setreAssignOpenDialog(true);
                          setSelectedRequest(req);
                        }}
                      >
                        <ReassignIcon />
                      </td>
                    )}
                  {(selectedFilter !== "inprogress" && selectedFilter !== "parked") ? (
                    <td>
                      {" "}
                      <Tooltip title={req.proposed_idea_x || ""} arrow>
                        {/* <td> */}
                        {req.proposed_idea_x?.slice(0, 15)}
                        {req.proposed_idea_x?.length > 15 ? "..." : ""}
                        {/* </td> */}
                      </Tooltip>
                    </td>
                  ) : (
                    <td
                      style={{
                        cursor: "pointer",
                        textDecoration: "underline",
                        color: "blue",
                      }}
                      onClick={() => {
                        setSelectedRequest(req);
                        setOpenDialog(true);
                      }}
                    >
                      <Tooltip title={req.proposed_idea_x || ""} arrow>
                        {/* <td> */}
                        {req.proposed_idea_x?.slice(0, 15)}
                        {req.proposed_idea_x?.length > 15 ? "..." : ""}
                        {/* </td> */}
                      </Tooltip>
                    </td>
                  )}

                  <td>{req.partno}</td>

                  <Tooltip title={req.benefit || ""} arrow>
                    <td>
                      {req.benefit?.slice(0, 15)}
                      {req.benefit?.length > 15 ? "..." : ""}
                    </td>
                  </Tooltip>

                  <td>{req.idea_effective}</td>

                  <td>{req.varient}</td>

                  <td
                    style={{ cursor: "pointer" }}
                    onClick={() => handleViewMore(req)}
                  >
                    <FormatListBulletedIcon />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Request Details</DialogTitle>
        <DialogContent dividers>
          <AlertDialogForm
            request={selectedRequest}
            setRefreshApi={setRefreshApi}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={reAssignOpenDialog}
        onClose={handleReassignCloseDialog}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>ReAssign</DialogTitle>
        <DialogContent dividers>
          <ReassignAlertDialogForm
            request={selectedRequest}
            setRefreshApi={setRefreshApi}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleReassignCloseDialog} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog for View More */}
      <Dialog
        open={viewMoreOpenDialog}
        onClose={handleViewMoreCloseDialog}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle>Idea Details </DialogTitle>
        <DialogContent>
          {selectedIdea && (
            <Grid container spacing={2}>
              {/* Left Column */}
              <Grid item xs={10} sm={6}>
                <Typography variant="body1">
                  <strong>Employee Id:</strong> {selectedIdea.emp_id}
                </Typography>
                <Typography variant="body1">
                  <strong>Employee Email:</strong> {selectedIdea.emp_email}
                </Typography>
                <Typography variant="body1">
                  <strong>SW Id:</strong> {selectedIdea.idea_unique_id}
                </Typography>
                {/* <Typography variant="body1">
                  <strong>Status:</strong>{" "}
                  <span style={{ color: getStatusColor(selectedIdea.status) }}>
                    {selectedIdea.status}
                  </span>
                </Typography> */}
                <Typography variant="body1">
                  <strong>Idea Category:</strong> {selectedIdea.idea_category}
                </Typography>
                <Typography variant="body1">
                  <strong>Part No:</strong> {selectedIdea.partno}
                </Typography>
                <Typography variant="body1">
                  <strong>Description:</strong> {selectedIdea.part_description}
                </Typography>
                <Typography variant="body1">
                  <strong>Proposed Idea:</strong> {selectedIdea.proposed_idea_x}
                </Typography>
                <Typography variant="body1">
                  <strong>Current Condition:</strong>{" "}
                  {selectedIdea.current_condition}
                </Typography>
                {/* {sourcingEmpIds.includes(currentEmpId) ? ( */}
                <Typography variant="body1">
                  <strong>Sourcing Comments:</strong>{" "}
                  {selectedIdea.il1_sourcing_comment}
                </Typography>
                {/* ) : ( */}
                <Typography variant="body1">
                  <strong>PD Comments:</strong> {selectedIdea.il1_pd_comment}
                </Typography>
                {/* )} */}
              </Grid>
              {/* Right Column */}
              <Grid item xs={12} sm={6}>
                <Typography variant="body1">
                  <strong>Savings:</strong> {selectedIdea.benefit}
                </Typography>
                <Typography variant="body1">
                  <strong>Aggregate:</strong> {selectedIdea.idea_effective}
                </Typography>
                <Typography variant="body1">
                  <strong>Model:</strong> {selectedIdea.model}
                </Typography>
                <Typography variant="body1">
                  <strong>Variant:</strong> {selectedIdea.varient}
                </Typography>

                <Typography variant="body1">
                  <strong>Sub Variant:</strong> {selectedIdea.subvarient}
                </Typography>
                <Typography variant="body1">
                  <strong>Domain:</strong> {selectedIdea.domain}
                </Typography>
                <Typography variant="body1">
                  <strong>Function:</strong> {selectedIdea.function}
                </Typography>
                <Typography variant="body1">
                  <strong>Location:</strong> {selectedIdea.location}
                </Typography>

                <Typography variant="body1">
                  <strong>Document:</strong>{" "}
                  {selectedIdea.filepath ? (
                    <button
                      style={{
                        cursor: "pointer",
                        color: "blue",
                        border: "transparent",
                        background: "transparent",
                      }}
                      onClick={() => downloadUploadedUserDocApi(selectedIdea)}
                    >
                      Download File
                    </button>
                  ) : (
                    "No File"
                  )}
                </Typography>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleViewMoreCloseDialog} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Stack alignItems="center" marginTop={1} color="white">
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={(event, value) => setCurrentPage(value)}
          color="primary"
          variant="outlined"
          shape="circular"
          sx={{
            "& .MuiPaginationItem-root": {
              color: "black",
              borderColor: "black",
              backgroundColor: "white",
            },
            "& .Mui-selected": {
              backgroundColor: "green",
              color: "white",
            },
          }}
        />
      </Stack>
    </div>
  );
}

export default SwitchOnUserShowingList;
